<script>
  export default {
    mounted() {
      this.$root.botaoAcaoMostrar = true;
    }
  }
</script>

<template>
  <div>
    <keep-alive exclude="DetalharProjeto">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/Projetos.vue